import kamala from '../../kamala'
import Calendar from './Calendar'

const KCalendarFamily = {
  install: function (Vue) {
    kamala(Vue)
    Vue.component(Calendar.name, Calendar)
  },
  KCalendar: Calendar,
}

export {
  Calendar,
}

export default KCalendarFamily
